export default __webpack_public_path__ + "static/media/reseller.e021163f.png";